// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { TimeLockType } from './time-lock-type';

/// <code-import> Place custom imports between <code-import> tags
export type TimeLockFlags = 'AllowJobAllocationAndMemo' | 'AllowPosting';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeLock extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  hasFlag(flag: TimeLockFlags): boolean {
    const flags = this.parseFlags();
    return flags.some((f) => f === flag);
  }

  setFlag(flag: TimeLockFlags): void {
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: TimeLockFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = this.parseFlags();
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  private parseFlags(): string[] {
    const flags = this.flags || '0'; // Could be numeric zero
    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adminId?: number;
  createdAt!: Date;
  createdBy?: string;
  flags!: string;
  lockedDate!: Date;
  timeLockTypeId!: number;
  updatedAt!: Date;
  updatedBy?: string;
  timeLockType!: TimeLockType;
}

